import { useContext, useEffect, useState } from "react";
import { Grid, TextField, Typography, Card, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import AuxAlert from "../../../components/alert";
import { GetDatos, UpdateDatosContacto } from "../../../controllers/company/CompanyProfileController";
import PhoneInput from "react-phone-input-2";
import UserContext from "../../../navigation/context/userContext";

export default function Contactos(props) {
    const { userData } = useContext(UserContext);
    const [phone, setPhone] = useState('');
    const [errorPhone, setErrorPhone] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(true);

    useEffect(() => { getInfo(); }, []);

    const getInfo = async () => {
        let response = await GetDatos();
        if (response.success) {
            setPhone(response.data.empresa.phone || '');
        }
    }

    const handleUpdateDatosContacto = async () => {
        if (phone === '') { setErrorPhone(true); return; }
        
        setIsLoading(true);
        let response = await UpdateDatosContacto(phone);
        setSuccess(response.success);
        setTitle(response.success ? 'Operación Exitosa' : 'Operación Fallida');
        setMessage(response.message);
        setOpen(true);
        setTimeout(() => setOpen(false), 5000);
        setIsLoading(false);
    }

    const cardStyle = { elevation: 0, sx: { border: '1px solid #e0e0e0', borderRadius: 3, p: { xs: 2, sm: 4 }, bgcolor: '#ffffff', maxWidth: 800 } };

    return (
        <Card {...cardStyle}>
            <Grid container spacing={3}>
                <Grid item xs={12} display='flex' flexDirection={{ xs: 'column', sm: 'row' }} justifyContent='space-between' alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
                    <Box>
                        <Typography variant='h6' sx={{ fontWeight: 800, color: '#222' }}>Datos de Contacto</Typography>
                        <Typography variant="body2" color="text.secondary">¿Cómo pueden contactarte tus clientes?</Typography>
                    </Box>
                    <LoadingButton
                        loading={isLoading}
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={handleUpdateDatosContacto}
                        disableElevation
                        sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}
                    >
                        Actualizar
                    </LoadingButton>
                </Grid>
                
                <Grid item xs={12}>
                    <TextField
                        disabled
                        fullWidth
                        size="small"
                        variant="outlined"
                        label='Correo electrónico principal'
                        value={userData.entity.email}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary" fontWeight="bold" sx={{ mb: 1, display: 'block' }}>Teléfono Público</Typography>
                    <PhoneInput
                        specialLabel=""
                        inputStyle={{ width: '100%', height: '40px', borderColor: errorPhone ? 'red' : '#ccc' }}
                        value={phone}
                        onChange={(e) => { setPhone(e); setErrorPhone(false); }}
                    />
                    {errorPhone && <Typography variant="caption" color="error.main">El teléfono es requerido.</Typography>}
                </Grid>
            </Grid>
            <AuxAlert open={open} success={success} title={title} message={message} />
        </Card>
    );
}